import { includes, map, get, filter, isEmpty, every, groupBy, presence, some } from 'lodash'

const filteredVMData = ({ vms, filters }) => filter(get(vms, 'data', vms), (vm) => {
  const filterResults = {}

  if (filters.vendors != 'All') {
    filterResults['vendors'] = includes(
      map(filters.vendors, 'value'),
      get(vm, 'vendor')
    )
  }

  if (filters.editions != 'All') {
    filterResults['editions'] = includes(
      map(filters.editions, 'value'),
      get(vm, 'operating_system_edition')
    )
  }

  if (filters.functions != 'All') {
    filterResults['function'] = includes(
      map(filters.functions, 'value'),
      get(vm, 'cluster.function')
    )
  }

  if (filters.ownerships != 'All') {
    filterResults['ownership'] = includes(
      map(filters.ownerships, 'value'),
      get(vm, 'cluster.ownership')
    )
  }

  if (filters.powerState != 'All') {
    filterResults['powerState'] = filters.powerState === get(vm, 'power_state', '').replace('Powered', '')
  }

  if (filters.operating_systems != 'All') {
    filterResults['operating_systems'] = includes(
      map(filters.operating_systems, 'value'),
      get(vm, 'operating_system')
    )
  }

  if (filters.clusters != 'All') {
    filterResults['clusters'] = includes(
      map(filters.clusters, 'value'),
      get(vm, 'cluster.id')
    )
  }

  if (filters.machine_type_sources != 'All') {
    filterResults['machine_type_sources'] = includes(
      map(filters.machine_type_sources, 'value'),
      get(vm, 'machine_type_source')
    )
  }

  if (filters.locations != 'All') {
    filterResults['locations'] = includes(
      map(filters.locations, 'value'),
      get(vm, 'location_id')
    )
  }

  if (filters.customers != 'All') {
    filterResults['customers'] = includes(
      map(filters.customers, 'value'),
      get(vm, 'viaje_client_id')
    )
  }

  if (filters.resources != 'All') {
    filterResults['resources'] = includes(
      map(filters.resources, 'value'),
      get(vm, 'parent_asset_tag')
    )
  }

  if (filters.licensableSoftware != 'All') {
    filterResults['licensableSoftware'] = some(
      map(filters.licensableSoftware, 'value'), (software) => includes(get(vm, 'name'), software)
    )
  }

  if (filters.licensableSoftwareGroups != 'All') {
    filterResults['licensableSoftwareGroups'] = includes(
      map(filters.licensableSoftwareGroups, 'value'),
      get(vm, 'family')
    )
  }

  if (filters.applicationEditions != 'All') {
    filterResults['applicationEditions'] = includes(
      map(filters.applicationEditions, 'value'),
      get(vm, 'edition')
    )
  }

  if (filters.regions != 'All') {
    filterResults['regions'] = includes(
      map(filters.regions, 'value'),
      get(vm, 'region_name')
    )
  }

  if (filters.platformTypes != 'All') {
    filterResults['platformTypes'] = includes(map(filters.platformTypes, 'value'), get(vm, 'platform_type'))
  }

  return (every(filterResults, (value, _key) => value === true) || isEmpty(filterResults))
})


const groupedData = (groupKey, data) => {
  const groupingFunctions = {
    Cluster: () => map(groupBy(data, 'cluster.id'), (softwares, clusterId) => ({
      clusterId: presence(clusterId, 'Unknown'),
      location: get(softwares[0], 'location_name'),
      cluster: get(softwares[0], 'cluster', {}),
      softwares: filter(softwares, ['vendor', 'Microsoft'])
    })),
    OperatingSystem: () => map(groupBy(data, 'operating_system'), (softwares, operating_system) => ({
      operating_system: presence(operating_system, 'Unknown'),
      softwares: filter(softwares, ['vendor', 'Microsoft'])
    })),
    Application: () => map(groupBy(data, 'name'), (softwares, application) => ({
      application: presence(application, 'Unknown'),
      softwares: filter(softwares, ['vendor', 'Microsoft'])
    })),
    Vendor: () => map(groupBy(data, 'vendor'), (softwares, location) => ({
      location: presence(location, 'Unknown'),
      softwares: filter(softwares, ['vendor', 'Microsoft'])
    })),
    Customer: () => map(groupBy(data, 'customer_name'), (softwares, customer) => ({
      customer: presence(customer, 'Unknown'),
      softwares: filter(softwares, ['vendor', 'Microsoft'])
    }))
  }

  return get(groupingFunctions, groupKey, () => [])()
}

const filteredSoftwareData = (filters, assets) => filter(assets, (asset) => {
  const filterResults = {}

  if (filters.applicationEditions != 'All') {
    filterResults['applicationEditions'] = includes(map(filters.applicationEditions, 'value'), get(asset, 'edition'))
  }

  if (filters.regions != 'All') {
    filterResults['regions'] = includes(map(filters.regions, 'value'), get(asset, 'region_name'))
  }

  if (filters.customers != 'All') {
    filterResults['customers'] = includes(map(filters.customers, 'value'), get(asset, 'viaje_client_id'))
  }

  if (filters.customersStatus != 'All') {
    filterResults['customersStatus'] = includes(map(filters.customersStatus, 'value'), get(asset, 'customer_status'))
  }

  if (filters.resources != 'All') {
    filterResults['resources'] = includes(map(filters.resources, 'value'), get(asset, 'parent_asset_tag'))
  }

  if (filters.platformTypes != 'All') {
    filterResults['platformTypes'] = includes(map(filters.platformTypes, 'value'), get(asset, 'platform_type'))
  }

  return (every(filterResults, (value, _key) => value === true) || isEmpty(filterResults))
})

export { filteredVMData, filteredSoftwareData, groupedData }
